import {CApiNotification} from './CApiNotification';

import type {JsonObject} from '../../../../HeliportJS/dist/models/json';
import type {AvatarInfoDocument} from '../../types/network';

export class CAvatarInfoApiNotification {
  addPosChannelEvent(fn: (avatarInfoDocument: AvatarInfoDocument) => void) {
    CApiNotification.addEventListener(
      'PositionChannel',
      'AvatarInfo',
      fn as (params: JsonObject) => void
    );
  }
}
